import { Injectable } from '@angular/core';


import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { Platform, LoadingController } from 'ionic-angular';
import { Facebook } from '@ionic-native/facebook';
import { GooglePlus } from '@ionic-native/google-plus';

import * as env from '../../app/shared/env';

import { WebService } from '../../app/shared/web.service';

import { BrowserStorageService } from './storage.service';
import { ToastService } from './toast.service';

@Injectable()
export class AuthService {

  user = {
    displayname: null,
    userid: null,
    sub: null,
    apppref: null,
    corepref: null
  }

  constructor(private afAuth: AngularFireAuth, private fb: Facebook, private google: GooglePlus, private platform: Platform,
    private web: WebService, private storage: BrowserStorageService, private toast: ToastService) {

    // this.afAuth.authState.subscribe(user => {
    //   console.log(user);
    //   if (!user) {
    //     this.displayName = null;
    //     return;
    //   }

    //   this.displayName = user.getIdToken().then(function(token) {
    //     return web.post(env.authBaseUrl + "/loginfb/vote", {"token":token}).subscribe(
    //       data => {
    //         console.log(data)
    //         return data.token;
    //       },
    //       err => {
    //         console.log(err)
    //       }
    //     );
    //   });

    //   console.log(this.displayName);
    // });

  }

  getDisplayname() {
    return this.user != null ? this.user.displayname : 'Anonymous';
  }

  getUserid() {
    return this.user != null ? this.user.userid : 0;
  }

  getSub() {
    return this.user != null ? this.user.sub : null;
  }
  
  getApppref() {
    return this.user != null ? this.user.apppref : null;
  }

  getCorepref() {
    return this.user != null ? this.user.corepref : null;
  }

  getUserpic(id, nocache) {
    if (id == null) id = this.user.userid;
    return env.centralMediaURL + 'images/' + ("00000" + (Math.floor(id / 1000))).slice(-5) + '/Reg.' + id + '.1.jpg' + (nocache ? '?rt=' + nocache : '');
  }

  getAuthToken() {
    return this.storage.get('auth_token');    
  }

  loadUser() {
    let token = this.storage.get('auth_token');
    if (token && token.split('.').length === 3) {
      let base64Url = token.split('.')[1];
      this.user = JSON.parse(atob(base64Url));
      console.log(this.user);
      return;
    }
    this.user == null;
    //this.afAuth.auth.signOut();
  }

  setUser(token) {
    this.storage.set('auth_token', token);
    this.loadUser();
  }

  loginBooshay(user) {
    console.log(user);
    console.log('Start loginBooshay');
    return user.getIdToken().then(token => {
      console.log('loginBooshay getIdToken');
      return new Promise((resolve, reject) => {
        return this.web.post(env.authBaseUrl + "/loginfb/" + env.appName, { token: token }).subscribe(data => {
          console.log('loginBooshay loginfb');
          this.setUser(data.token);
          //this.storage.set('auth_token', data.token);
          //this.loadUser();
          return resolve(data.token);
        }, err => {
          console.log(err);
          reject(err);
        });
      })
    });
  }


  isAuth() {
    return this.user != null && this.user.userid != null;
  }

  signInWithFacebook() {
    if (this.platform.is('cordova')) {
      console.log('signInWithFacebook cordova');
      return this.fb.login(['email', 'public_profile']).then(res => {
        console.log('signInWithFacebook login');
        const cred = firebase.auth.FacebookAuthProvider.credential(res.authResponse.accessToken);
        return firebase.auth().signInWithCredential(cred).then(res => {
          console.log('signInWithFacebook firebase');
          return this.loginBooshay(res);
        });
      })
    }
    else {
      return new Promise((resolve, reject) => {
        console.log('signInWithFacebook Promise');
        return this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider()).then(res => {
          console.log('signInWithFacebook signInWithPopup');
          return this.loginBooshay(res.user).then(res => {
            console.log('signInWithFacebook loginBooshay');
            return resolve(res);
          });
        });
      })
    }
  }

  signInWithGoogle() {


    if (this.platform.is('cordova')) {
      console.log('signInWithGoogle cordova');
      return this.google.login({ 'webClientId': '1014135877824-vhrdk620vv6iuk6jtgp21713lvohungm.apps.googleusercontent.com', 'offline': true }).then(res => {
        console.log('signInWithGoogle login');
        console.log(res);
        const cred = firebase.auth.GoogleAuthProvider.credential(res.idToken);
        return firebase.auth().signInWithCredential(cred).then(res => {
          console.log('signInWithGoogle firebase');
          return this.loginBooshay(res);
        });
      }, err => {
        console.log(err);
      });
    }
    else {
      return new Promise((resolve, reject) => {
        console.log('signInWithFacebook Promise');
        return this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(res => {
          console.log('signInWithFacebook signInWithPopup');
          return this.loginBooshay(res.user).then(res => {
            console.log('signInWithFacebook loginBooshay');
            return resolve(res);
          });
        });
      })
    }
  }

  signInWithEmail(email: string, password: string) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password).then(res => {
      console.log(res);
      if (res.emailVerified) return this.loginBooshay(res);
      this.toast.error("Email has not been verified");
    });
  }

  recoverPassword(email: string) {
    return this.afAuth.auth.sendPasswordResetEmail(email).then(res => {
      //return this.loginBooshay(res);
      console.log(res);
    });
  }

  signUpWithEmail(email: string, password: string, displayname: string) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password).then(res => {
      console.log(res);
      this.afAuth.auth.currentUser.sendEmailVerification();
      return this.afAuth.auth.currentUser.updateProfile({ displayName: displayname, photoURL: null }).then(res2 => {
        console.log(res2);
        return res2;
      });
    });
  }

  verifyEmail(code: string) {
    return this.afAuth.auth.applyActionCode(code).then(res => {
      console.log(res);
      console.log(this.afAuth.auth.currentUser);
      return this.loginBooshay(this.afAuth.auth.currentUser).then(res => {
        this.toast.info("Email has been verified. You have been signed in.");
            console.log('verifyEmail loginBooshay');
            return res;
          });
    }, err => {
      this.toast.error("Unable to verify email");
      console.log(err);
      console.log(this.afAuth.auth.currentUser);
    });
  }

  resetPassword(code: string, password:string) {
    return this.afAuth.auth.verifyPasswordResetCode(code).then(res => {
      console.log(res);
      return this.afAuth.auth.confirmPasswordReset(code, password).then(res => {
        console.log(res);
        console.log(this.afAuth.auth.currentUser);
        this.toast.info("Password has been changed. Please sign in to continue.");
      }, err => {
      this.toast.error("Unable to reset password");
      console.log(err);
    });
    }, err => {
      this.toast.error("Unable to verify email");
      console.log(err);
    });
  }

  signOut() {
    return this.afAuth.auth.signOut().then(res => {
      this.user = null;
      this.storage.remove('auth_token');
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/auth.service.ts